import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcLoad = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 1.5C17.799 1.5 22.5 6.20101 22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z"
      fill="currentColor"
    />
    <path
      d="M12 5.04785C13.2333 5.04785 14.4447 5.37368 15.5116 5.99236C16.5784 6.61104 17.4629 7.5006 18.0755 8.571C18.688 9.64139 19.0069 10.8546 18.9999 12.0879C18.9928 13.3212 18.6601 14.5307 18.0353 15.594C17.4105 16.6573 16.5159 17.5367 15.442 18.1431C14.3682 18.7496 13.1531 19.0615 11.9199 19.0474C10.6867 19.0333 9.47913 18.6936 8.4194 18.0628C7.35967 17.4319 6.48542 16.5323 5.88514 15.455L12 12.0479V5.04785Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgIcLoad;
